import type { IBCKSKepalaSekolahEligibility, ValidatedString } from 'types/bcks'

export const getIsValidData = (data: ValidatedString | undefined) => {
  return !!data && !!data.value && !data.validation
}

export const getIsValidIdentity = (
  identity: IBCKSKepalaSekolahEligibility['identity']
) => {
  return getIsValidData(identity.umur)
}

export const getIsValidCertificate = (
  certificate: IBCKSKepalaSekolahEligibility['certificate']
) => {
  return (
    getIsValidData(certificate.nomorSertifikatPendidik) &&
    (getIsValidData(certificate.nomorSertifikatGp) ||
      getIsValidData(certificate.nomorSertifikatNrks))
  )
}

export const getIsValidQualification = (
  qualification: IBCKSKepalaSekolahEligibility['qualification']
) => {
  if (qualification.statusKepegawaian.value === 'PPPK') {
    return (
      getIsValidData(qualification.kualifikasiAkademik) &&
      getIsValidData(qualification.statusKepegawaian)
    )
  }

  return (
    getIsValidData(qualification.kualifikasiAkademik) &&
    getIsValidData(qualification.statusKepegawaian) &&
    getIsValidData(qualification.pangkatGolongan)
  )
}
